import { isEmpty, sanitizeValues } from '@intelligence/v3/utils/common';
import { resolveUrlField } from './fieldMapUtils';
import { buildStringArrayApiParamsByItem } from './valueUtils';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';
import type { IFilterMiddlewareUtils } from './types';

const parseStringArrayFilterUrlValue = (searchParams: URLSearchParams, field: string): string[] | null => {
  const rawValue = searchParams.get(field) || '';

  if (isEmpty(rawValue)) {
    return null;
  }

  const values = sanitizeValues(rawValue.split(',').map((item) => item.trim()));

  return isEmpty(values) ? null : values;
};

/**
 * string[] 类型筛选器的通用中间件工具类
 *
 * 适用于 regionSelect / platform / dataSource /
 *       companySelect / tagSelect / sensorTowerTheme
 */
export class StringArrayMiddlewareUtils implements IFilterMiddlewareUtils<string[], IRecord<string[]>> {
  convertToApiParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string[]> | null {
    return buildStringArrayApiParamsByItem(item, filterValue, params);
  }

  deserializeUrlParams(item: IFilterItemConfig, searchParams: URLSearchParams, params?: unknown): string[] | null {
    if (isEmpty(searchParams)) {
      return null;
    }

    const field = resolveUrlField(item, undefined, params);

    if (isEmpty(field)) {
      return null;
    }

    return parseStringArrayFilterUrlValue(searchParams, field);
  }

  getManagedUrlKeys(item: IFilterItemConfig, params?: unknown): string[] {
    const field = resolveUrlField(item, undefined, params);

    return isEmpty(field) ? [] : [field];
  }

  serializeUrlParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string> {
    if (isEmpty(filterValue)) {
      return {};
    }

    const unique = sanitizeValues(filterValue);
    if (isEmpty(unique)) {
      return {};
    }

    const field = resolveUrlField(item, undefined, params);

    if (isEmpty(field)) {
      return {};
    }

    return { [field]: unique.join(',') };
  }
}
